export default __webpack_public_path__ + "static/media/in_arrow_v2.f3ebe7a6.png";